import { useState, useRef, useEffect, FC } from 'react';
import { Transition, Dimmer, Grid } from 'semantic-ui-react';


export interface DropProps {
    onDrop(files: File[], path?: string): Promise<void>;
    path?: string;
}

const Dropzone: FC<DropProps> = ({ onDrop, path}) => {
    const [dragging, setDragging] = useState(false);
    const timer = useRef<any>(0);

    useEffect(() => {
        const listeners: any = {
            'dragover': (e: Event) => {
                setDragging(true);
                clearTimeout(timer.current);
                e.preventDefault();
                e.stopPropagation();
            },
            'dragleave': (e: Event) => {
                e.preventDefault();
                e.stopPropagation();
                timer.current = setTimeout(() => setDragging(false), 300);
            },
            'drop': (e: DragEvent) => {
                e.preventDefault();
                e.stopPropagation();
                setDragging(false);
                const { files } = e.dataTransfer ?? {};

                if (files) {
                    onDrop(Array.from(files), path);
                }
            }
        };


        Object
            .entries(listeners)
            .forEach(([event, listener]: any) => document.addEventListener(event, listener));

        return () => Object
            .entries(listeners)
            .forEach(([event, listener]: any) => document.removeEventListener(event, listener));
    }, []);


    return (
        <div style={{
            display: dragging ? 'block' : 'none',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            position: 'fixed',
            zIndex: 2
        }}>
            <Transition duration={{ hide: 250, show: 250}} visible={dragging}>
                <Dimmer blurring active={true}>
                    <Grid>
                        <Grid.Row></Grid.Row>
                        <Grid.Row style={{ borderStyle: 'dashed', padding: 100, fontSize: '20pt' }}>
                            Drop files to upload them
                        </Grid.Row>
                        <Grid.Row></Grid.Row>
                    </Grid>
                </Dimmer>
            </Transition>
        </div>
    );
};


export default Dropzone;